module.exports = __webpack_public_path__ + "img/LQS Analyser.d1a9ddc2.svg";